var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEuSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 0.695557L8.38858 1.89129H9.64576L8.62862 2.63028L9.01717 3.82601L8.00003 3.08698L6.98284 3.82601L7.37139 2.63028L6.35425 1.89129H7.61148L8.00003 0.695557Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83523 2.83503L3.95554 3.40578L4.84453 2.51685L4.64779 3.75856L5.76806 4.32936L4.52629 4.52605L4.32961 5.76786L3.75881 4.6476L2.51709 4.84433L3.40607 3.95535L2.83523 2.83503Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.695801 7.99979L1.89153 7.61124V6.354L2.63047 7.37119L3.82625 6.98264L3.08717 7.99979L3.82625 9.01693L2.63047 8.62843L1.89153 9.64557V8.38833L0.695801 7.99979Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83523 13.165L3.40603 12.0446L2.51709 11.1557L3.75886 11.3524L4.32956 10.2322L4.52629 11.4739L5.76801 11.6706L4.64789 12.2414L4.84453 13.4831L3.95554 12.5942L2.83523 13.165Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 15.3042L7.61144 14.1085H6.35425L7.37144 13.3695L6.98284 12.1738L8.00003 12.9128L9.01717 12.1738L8.62862 13.3695L9.64576 14.1085H8.38853L8.00003 15.3042Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1652 13.165L12.0449 12.5942L11.1559 13.4832L11.3526 12.2414L10.2324 11.6706L11.4741 11.4739L11.6708 10.2322L12.2416 11.3524L13.4833 11.1557L12.5943 12.0447L13.1652 13.165Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3044 7.99979L14.1087 8.38833V9.64557L13.3697 8.62838L12.1741 9.01693L12.9131 7.99979L12.1741 6.98264L13.3698 7.37119L14.1087 6.354V7.61129L15.3044 7.99979Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1652 2.83499L12.5944 3.9553L13.4833 4.84428L12.2415 4.6475L11.6708 5.76777L11.4741 4.526L10.2324 4.32927L11.3526 3.75852L11.1559 2.51685L12.0449 3.40578L13.1652 2.83499Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuSmall);
export default __webpack_public_path__ + "static/media/iconEuSmall.7caa62a8963cdad450c0384fd2e8c42f.svg";
export { ForwardRef as ReactComponent };